import type { Location } from './types'

/* Live location registry (one entry per warehouse). Populated by
   InventoryProvider from the GraphQL API. */
export let locations: Location[] = []

export function setLocations(next: Location[]): void {
  locations = next
}

export const locationById = (id: string) => locations.find((l) => l.id === id)
export const locationByCode = (code: string) =>
  locations.find((l) => l.code === code)
